"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flowPrefix = exports.temperatureOutPrefix = exports.steamPressurePrefix = exports.inputHumidityPrefix = exports.inputTemperaturePrefix = void 0;
exports.applyInputTemperatureDefaults = applyInputTemperatureDefaults;
exports.getInputTemperatures = getInputTemperatures;
exports.inputTemperatureName = inputTemperatureName;
exports.applyInputHumidityDefaults = applyInputHumidityDefaults;
exports.getInputHumidities = getInputHumidities;
exports.inputHumidityName = inputHumidityName;
exports.applySteamPressureDefaults = applySteamPressureDefaults;
exports.getSteamPressures = getSteamPressures;
exports.steamPressureName = steamPressureName;
exports.applyTemperatureOutDefaults = applyTemperatureOutDefaults;
exports.getTemperaturesOut = getTemperaturesOut;
exports.temperatureOutName = temperatureOutName;
exports.applyFlowDefaults = applyFlowDefaults;
exports.getFlows = getFlows;
exports.flowName = flowName;
const property_1 = require("@genesys/property");
const uom_1 = require("@genesys/uom");
function applyInputTemperatureDefaults(pvs, isExpressCalculateMode) {
    if (!isExpressCalculateMode) {
        return pvs;
    }
    const inputTemperatures = getInputTemperatures(pvs);
    return property_1.PropertyValueSet.merge(inputTemperatures.reduce((soFar, current, ix) => property_1.PropertyValueSet.setAmount(inputTemperatureName(ix), current, soFar), property_1.PropertyValueSet.Empty), pvs);
}
function getInputTemperatures(pvs) {
    const inputTemperatureMin = property_1.PropertyValueSet.getAmount("airinputstemperaturemin", pvs);
    const inputTemperatureMax = property_1.PropertyValueSet.getAmount("airinputstemperaturemax", pvs);
    const inputTemperatureStep = property_1.PropertyValueSet.getAmount("airinputstemperaturestep", pvs);
    if (uom_1.Amount.greaterOrEqualTo(inputTemperatureMin, inputTemperatureMax)) {
        return [];
    }
    const inputTemperatures = [];
    for (let inputTemperature = inputTemperatureMin; uom_1.Amount.lessOrEqualTo(inputTemperature, inputTemperatureMax) &&
        inputTemperatures.length <= 100; inputTemperature = uom_1.Amount.plus(inputTemperature, inputTemperatureStep)) {
        inputTemperatures.push(inputTemperature);
    }
    return inputTemperatures;
}
exports.inputTemperaturePrefix = "steppedairtemperature";
function inputTemperatureName(index) {
    return exports.inputTemperaturePrefix + "_" + index;
}
function applyInputHumidityDefaults(pvs, isExpressCalculateMode) {
    if (!isExpressCalculateMode) {
        return pvs;
    }
    const inputHumidities = getInputHumidities(pvs);
    return property_1.PropertyValueSet.merge(inputHumidities.reduce((soFar, current, ix) => property_1.PropertyValueSet.setAmount(inputHumidityName(ix), current, soFar), property_1.PropertyValueSet.Empty), pvs);
}
function getInputHumidities(pvs) {
    const inputHumidityMin = property_1.PropertyValueSet.getAmount("airinputshumiditymin", pvs);
    const inputHumidityMax = property_1.PropertyValueSet.getAmount("airinputshumiditymax", pvs);
    const inputHumidityStep = property_1.PropertyValueSet.getAmount("airinputshumiditystep", pvs);
    if (uom_1.Amount.greaterOrEqualTo(inputHumidityMin, inputHumidityMax)) {
        return [];
    }
    const inputHumidities = [];
    for (let inputHumidity = inputHumidityMin; uom_1.Amount.lessOrEqualTo(inputHumidity, inputHumidityMax) &&
        inputHumidities.length <= 100; inputHumidity = uom_1.Amount.plus(inputHumidity, inputHumidityStep)) {
        inputHumidities.push(inputHumidity);
    }
    return inputHumidities;
}
exports.inputHumidityPrefix = "steppedairhumidity";
function inputHumidityName(index) {
    return exports.inputHumidityPrefix + "_" + index;
}
function applySteamPressureDefaults(pvs, isExpressCalculateMode) {
    if (!isExpressCalculateMode) {
        return pvs;
    }
    const steamPressures = getSteamPressures(pvs);
    return property_1.PropertyValueSet.merge(steamPressures.reduce((soFar, current, ix) => property_1.PropertyValueSet.setAmount(steamPressureName(ix), current, soFar), property_1.PropertyValueSet.Empty), pvs);
}
function getSteamPressures(pvs) {
    const steamPressureMin = property_1.PropertyValueSet.getAmount("pressuremin", pvs);
    const steamPressureMax = property_1.PropertyValueSet.getAmount("pressuremax", pvs);
    const steamPressureStep = property_1.PropertyValueSet.getAmount("pressurestep", pvs);
    if (uom_1.Amount.greaterOrEqualTo(steamPressureMin, steamPressureMax)) {
        return [];
    }
    const steamPressures = [];
    for (let steamPressure = steamPressureMin; uom_1.Amount.lessOrEqualTo(steamPressure, steamPressureMax) &&
        steamPressures.length <= 100; steamPressure = uom_1.Amount.plus(steamPressure, steamPressureStep)) {
        steamPressures.push(steamPressure);
    }
    return steamPressures;
}
exports.steamPressurePrefix = "steppedpressure";
function steamPressureName(index) {
    return exports.steamPressurePrefix + "_" + index;
}
//----------------------------------------------------------
//----------------------------------------------------------
//----------------------------------------------------------
function applyTemperatureOutDefaults(pvs, isExpressCalculateMode) {
    if (!isExpressCalculateMode) {
        return pvs;
    }
    const temperaturesOut = getTemperaturesOut(pvs);
    return property_1.PropertyValueSet.merge(temperaturesOut.reduce((soFar, current, ix) => property_1.PropertyValueSet.setAmount(temperatureOutName(ix), current, soFar), property_1.PropertyValueSet.Empty), pvs);
}
function getTemperaturesOut(pvs) {
    const temperatureOutMin = property_1.PropertyValueSet.getAmount("temperatureoutmin", pvs);
    const temperatureOutMax = property_1.PropertyValueSet.getAmount("temperatureoutmax", pvs);
    const temperatureOutStep = property_1.PropertyValueSet.getAmount("temperatureoutstep", pvs);
    if (uom_1.Amount.greaterOrEqualTo(temperatureOutMin, temperatureOutMax)) {
        return [];
    }
    const temperaturesOut = [];
    for (let temperatureOut = temperatureOutMin; uom_1.Amount.lessOrEqualTo(temperatureOut, temperatureOutMax) &&
        temperaturesOut.length <= 100; temperatureOut = uom_1.Amount.plus(temperatureOut, temperatureOutStep)) {
        temperaturesOut.push(temperatureOut);
    }
    return temperaturesOut;
}
exports.temperatureOutPrefix = "steppedtemperatureout";
function temperatureOutName(index) {
    return exports.temperatureOutPrefix + "_" + index;
}
function applyFlowDefaults(pvs, isExpressCalculateMode) {
    if (!isExpressCalculateMode) {
        return pvs;
    }
    const flows = getFlows(pvs);
    return property_1.PropertyValueSet.merge(flows.reduce((soFar, current, ix) => property_1.PropertyValueSet.setAmount(flowName(ix), current, soFar), property_1.PropertyValueSet.Empty), pvs);
}
function getFlows(pvs) {
    const flowMin = property_1.PropertyValueSet.getAmount("flowmin", pvs);
    const flowMax = property_1.PropertyValueSet.getAmount("flowmax", pvs);
    const flowStep = property_1.PropertyValueSet.getAmount("flowstep", pvs);
    if (uom_1.Amount.greaterOrEqualTo(flowMin, flowMax)) {
        return [];
    }
    const flows = [];
    for (let flow = flowMin; uom_1.Amount.lessOrEqualTo(flow, flowMax) && flows.length <= 100; flow = uom_1.Amount.plus(flow, flowStep)) {
        flows.push(flow);
    }
    return flows;
}
exports.flowPrefix = "steppedflow";
function flowName(index) {
    return exports.flowPrefix + "_" + index;
}
//# sourceMappingURL=functions.js.map